import ActionButton from "@/components/Button/ActionButton";
import Icon from "@/components/Icon/Icon";
import { VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { Link } from "@tanstack/react-router";

type Props = {
  completeLinkButton: string;
  completeLinkUrl: string;
};

const CompleteDialog = ({ completeLinkButton, completeLinkUrl }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.completeDialog",
  });

  return (
    <Dialog open={true}>
      <DialogContent className="max-w-dialog-sm" hideCloseButton={true}>
        <VStack className="gap-4 px-6 py-9">
          <div className="flex flex-col justify-center items-center p-5">
            <Icon
              iconName="CircleCheckBigIcon"
              colorVariant="success"
              className="h-[40px] w-[40px]"
            />
          </div>

          <div className="flex flex-col justify-center items-center">
            <Text variant="h3">{t("message")}</Text>
          </div>

          <div className="flex flex-col justify-center items-center px-3 py-4">
            <Link to={completeLinkUrl}>
              <ActionButton variant="neutral">
                {completeLinkButton}
              </ActionButton>
            </Link>
          </div>
        </VStack>
      </DialogContent>
    </Dialog>
  );
};

export default CompleteDialog;
